export default "__VITE_ASSET__CHA1diNl__"